/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Components.Controls.SmartMover {

    angular.module('meevo.components.controls.SmartMover', []);
}